exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-c8a70580] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.svg-external-icon[data-v-c8a70580] {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n", ""]);

// exports
